import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Logo,
  MenuCont,
  MenuElement,
  SideMenuCont,
  MenuBottomElement,
  LogoutIcon,
  ChangeLangCont,
  LogoutCont,
  ChangeOrgCont,
} from './SideMenu.styles';
import { RouteNames, routesAccessRights } from '../../constans/routes';
import { useAuth } from '../../hooks/useAuth';
import ChangeLangDrop from '../ChangeLangDrop/ChangeLangDrop';
import ChangeOrgDrop from '../ChangeOrgDrop/ChangeOrgDrop';

const sideMenuItems = [
  {
    title: 'surveys',
    route: `${RouteNames.Surveys}`,
    requiredRoles: routesAccessRights[RouteNames.Surveys],
  },
  {
    title: 'reports',
    route: `${RouteNames.Reports}`,
    requiredRoles: routesAccessRights[RouteNames.Reports],
  },
];

interface ISideMenu {
  activeView: string;
  changeView: (viewName: string) => void;
  isEBHRMember: boolean;
}

//TODO Fix errors and add hover on this menu

const SideMenu: FC<ISideMenu> = ({ changeView, activeView, isEBHRMember }) => {
  const { tokenAndRoleValidation } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { logOut } = useAuth();
  const doLogout = async () => {
    try {
      await logOut();
    } catch (e) {
      return e;
    }
  };

  useEffect(() => {
    if (pathname.includes(RouteNames.Reports)) {
      changeView('reports');
    }
  }, []);

  const renderItems = useMemo(() => {
    const itemsWithRights = sideMenuItems.filter((item: any) => {
      const itemRight = tokenAndRoleValidation(item.requiredRoles);

      if (itemRight) {
        return item;
      }
      return false;
    });

    return itemsWithRights.map((item: { title: string; route: string }) => (
      <MenuElement
        data-testid={`SideMenuEl-${item.title}`}
        id="MenuElement"
        key={item.title}
        noHover={item.title === activeView}
        onClick={() => {
          changeView(item.title);
          navigate(item.route);
        }}
        active={item.title === activeView}
      >
        {t(`surveys.stripMenu.${item.title}`)}
      </MenuElement>
    ));
  }, [activeView, changeView, t]);

  return (
    <MenuCont id="MenuCont">
      <SideMenuCont id="SideMenuCont">
        <Logo data-testid="SideMenuLogo" />
        {renderItems}
        <MenuBottomElement noHover id="MenuBottomElement">
          {!isEBHRMember && (
            <ChangeOrgCont>
              <ChangeOrgDrop anchor="top" />
            </ChangeOrgCont>
          )}
          <ChangeLangCont>
            <ChangeLangDrop anchor="top" />
          </ChangeLangCont>

          <LogoutCont
            data-testid="LogoutButton"
            onClick={async () => {
              changeView('logout');
              await doLogout();
            }}
          >
            <LogoutIcon id="LogoutIcon" />
            {t('surveys.stripMenu.logout')}
          </LogoutCont>
        </MenuBottomElement>
      </SideMenuCont>
    </MenuCont>
  );
};

export default SideMenu;
